import moment from 'moment-timezone/builds/moment-timezone-with-data'
import 'moment-timezone'

export function initDateTime(companyTimeZone) {
  moment.tz.setDefault(companyTimeZone)
}
// let ACTIVE_TZ
//
// function ensureInit() {
//   if (!ACTIVE_TZ) {
//     throw new Error('DateTime not initialized')
//   }
// }
//
// export function formatUtc(utcIso, format = 'YYYY-MM-DD HH:mm') {
//   ensureInit()
//   return moment
//     .utc(utcIso)
//     .tz(ACTIVE_TZ)
//     .format(format)
// }
//
// export function fromUtc(utcIso) {
//   ensureInit()
//   return moment.utc(utcIso).tz(ACTIVE_TZ)
// }
//
// export function localToUtcIso(localStr, format = 'YYYY-MM-DD HH:mm') {
//   ensureInit()
//   const m = moment.tz(localStr, format, true, ACTIVE_TZ)
//   return m.isValid() ? m.utc().toISOString() : null
// }
